import { StateCreator } from 'zustand';
import { isAxiosError } from 'axios';
import { toast } from 'react-toastify';
import { authLogin, authRegister, authSwitchTenant } from 'api/generated/endpoints/auth/auth';
import { extractErrorMessage } from 'api/mutator';
import { queryClient } from 'api/queryClient';
import { AuthStore, AuthFunctions } from '../types';

//? Login e troca de escritório vão com `silent`: um 401 de senha errada não pode cair no fluxo de "sessão expirada"
//? do mutator. A mensagem do backend é mostrada aqui, num toast só.
const silent = { silent: true };

function errorMessage(error: unknown, fallback: string): string {
    if (isAxiosError(error) && error.response) return extractErrorMessage(error.response.data, error.response.status);
    return fallback;
}

export const createFunctionsSlice: StateCreator<AuthStore, [], [], AuthFunctions> = (set, get) => ({
    setNavigate: (fn) => set({ _navigate: fn }),

    //#region Super Admin View
    setSuperAdminView: (value) => set({ superAdminView: !!get().data?.isAdmin && value }),

    //#region Login
    login: async (payload) => {
        set({ loading: true, error: null });
        try {
            const response = await authLogin(payload, silent);
            localStorage.setItem('token', response.tokenData.accessToken);
            //? Multi-tenant: nada do usuário/escritório anterior pode ficar em cache
            queryClient.clear();
            set({ data: response });
            const redirectTo = '/escritorio';
            get()._navigate?.(redirectTo, { replace: true });
            return true;
        } catch (error) {
            const message = errorMessage(error, 'Erro ao fazer login.');
            toast.error(message);
            set({ error: message });
            return false;
        } finally {
            set({ loading: false });
        }
    },

    //#region Logout
    logout: async () => {
        localStorage.removeItem('token');
        queryClient.clear();
        set({ data: null, superAdminView: false });
        //get()._navigate?.('/auth/login', { replace: true });
    },

    //#region Signup
    signup: async (payload) => {
        set({ loading: true, error: null });
        try {
            //? O erro do cadastro (ex.: e-mail já usado) aparece pelo toast do mutator
            const response = await authRegister(payload);
            return response;
        } catch (error) {
            set({ error: errorMessage(error, 'Erro ao criar conta.') });
            return null;
        } finally {
            set({ loading: false });
        }
    },

    //#region Switch Tenant
    switchTenant: async (tenantId, relationType) => {
        set({ loading: true, error: null });
        try {
            const response = await authSwitchTenant(tenantId, { relationType: String(relationType) }, silent);
            queryClient.clear();
            set({ data: response });
            window.location.reload();
            return true;
        } catch (error) {
            const message = errorMessage(error, 'Erro ao trocar empresa.');
            toast.error(message);
            set({ error: message });
            return false;
        } finally {
            set({ loading: false });
        }
    },
});
